import { render, staticRenderFns } from "./AddRulesLeftPage.vue?vue&type=template&id=97a62824&scoped=true"
import script from "./AddRulesLeftPage.vue?vue&type=script&lang=ts"
export * from "./AddRulesLeftPage.vue?vue&type=script&lang=ts"
import style0 from "./AddRulesLeftPage.vue?vue&type=style&index=0&id=97a62824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a62824",
  null
  
)

export default component.exports